import * as React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useMachine } from "@xstate/react";
import { useMemberProducts } from "@nju/data-access-portal-product";
import { pushSimpleEvent } from "@nju/data-layer";
import { portalRoutes } from "@nju/routes";
import {
  A,
  Button,
  GeneralErrorNotification,
  Panel,
  Separator,
  Text,
} from "@nju/ui";
import { mySimCardToggleBlockMachine } from "./mySimCardToggleBlock.machine";
import { MySimCardUnblockSuccess } from "./MySimCardUnblockSuccess";

export function MySimCardUnblock() {
  const router = useRouter();
  const params = portalRoutes.mojeKonto.mojaKarta.odblokowanieKartySim
    .input(router.query)
    .unwrap();
  const { mobileProducts: memberProducts } = useMemberProducts();
  const mobileProducts = memberProducts;
  const productId = mobileProducts.mobileAccess?.id;

  const [current, send] = useMachine(mySimCardToggleBlockMachine, {
    context: {
      productId,
      action: undefined,
    },
  });

  const { matches } = current;

  const unBlockSimCard = React.useCallback(() => {
    pushSimpleEvent({
      event: "activity_sim_status",
      eventName: "unblock_sim_resignation_confirmed",
    });
    send({ type: "UNBLOCK" });
  }, [send]);

  if (!mobileProducts) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  if (matches("success")) {
    return <MySimCardUnblockSuccess userId={params?.userId} />;
  }

  if (matches("error")) {
    return (
      <GeneralErrorNotification
        callback={() => {
          return window.location.reload();
        }}
      />
    );
  }

  return (
    <Panel>
      <Text
        size={{
          "@onlyMobile": "xl",
          "@fromTablet": "keyM",
        }}
        weight="bold"
      >
        odblokowanie karty SIM
      </Text>
      <Separator size="s" />
      <Text>Twoje usługi zostaną przywrócone. To może potrwać chwilę.</Text>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-between only-mobile:gap-3 only-mobile:flex-col-reverse flex-row">
        <Link
          href={portalRoutes.mojeKonto.mojaKarta.index.get({
            ...(params?.userId && { userId: params.userId }),
          })}
          passHref={true}
        >
          <A
            size={{
              "@onlyMobile": "s",
            }}
            variant="secondary"
          >
            anuluj
          </A>
        </Link>
        <Button
          isLoading={matches("setBlockSimCard")}
          onPress={unBlockSimCard}
          size={{ "@onlyMobile": "s" }}
        >
          odblokuj kartę
        </Button>
      </div>
    </Panel>
  );
}
